import React, { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  Grid,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import Forms from "./organisms/Forms";
import NextButton from "../../components/NextButton/NextButton";
import Error from "../../components/Error/Error";
import FormOperator from "../../components/FormOperator/FormOperator";
import PassengerTab from "./molecules/PassengerTab";
import PreviousStepBtn from "../../components/PreviousStepBtn/PreviousStepBtn";
import CustomPhoneNumber from "../../components/CustomPhoneNumber/CustomPhoneNumber";
import CustomTextField from "../../components/CustomTextField/CustomTextField";
import { CustomSwitch } from "../../components/Switch/Switch";
import PhoneContactIcon from "../../assets/img/contact.svg";
// import PlusIcon from "../../assets/img/plus.svg";
import useStyles from "./styles";
import Accreditation from "../../components/Accreditation/Accreditation";

export default function Step2({
  passengers,
  append,
  fields,
  remove,
  operatorInfo,
  handleBack,
  handleNext,
  extras,
  tipsValue,
  selectedFlight,
  airlines,
  control
}) {
  const classes = useStyles();
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down("xs"));
  const [activeIndex, setActiveIndex] = useState(0);
  const { formState, getValues } = useFormContext();

  const passengersValues = getValues("passengers");
  const contactDetailsSwitchVal =
    useWatch({ name: "contactDetailsSwitch" }) ||
    getValues("contactDetailsSwitch");
  const contactPhoneNumberVal = getValues("contactPhoneNumber");
  const formErrors = (({ cards, ...rest }) => rest)(formState?.errors);
  // console.log(formErrors, "formErrors");
  // console.log(formState, "formState");
  // console.log("STEP 2: fields", fields);
  // console.log("STEP 2: activeIndex ", activeIndex);
  // console.log("STEP 2: passengersValues ", passengersValues);

  const calcGridSize = (items) => {
    if (items > 3) {
      return 3;
    }
    if (items === 3) {
      return 4;
    }
    return 6;
  };
  const gridSize = calcGridSize(fields?.length);

  // const addNewPassenger = () => {
  //   append({
  //     firstName: "",
  //     lastName: "",
  //     middleName: "",
  //     gender: "",
  //     birthDate: null,
  //     seatPreference: "",
  //     mealPreference: "",
  //     specialAsistance: "",
  //   });
  //   setActiveIndex(fields?.length);
  // };

  const handlePrevAction = () => {
    window.scroll({ top: 0, behavior: "smooth" });
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleNextAction = () => {
    window.scroll({ top: 0, behavior: "smooth" });
    if (activeIndex < fields.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <PreviousStepBtn handleBack={handleBack} />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h1" align="center">
              Passenger details
            </Typography>
          </Box>
        </Box>
        <Box
          mt={1}
          mb={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Error
            errorMessage="Passenger names must be entered exactly as in the passport or a government issued ID.
            Name changes are not permitted after booking."
          />
        </Box>
        {passengers > 1 && (
          <Grid container spacing={1} className={classes.tabSection}>
            {fields.map((field, idx) => (
              <Grid key={field?.id} item xs={12} sm={gridSize}>
                <PassengerTab
                  index={idx}
                  field={field}
                  isActive={idx === activeIndex}
                  remove={remove}
                  setActiveIndex={setActiveIndex}
                  // showDelete={fields.length > 1 && idx === activeIndex}
                  showDelete={false}
                  errors={formState.errors.passengers || []}
                  resetActiveIndex={() => setActiveIndex(0)}
                  passengersValues={passengersValues}
                />
              </Grid>
            ))}
            {/* {fields.length < passengers && (
            <Grid item xs={gridSize}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className={classes.addNewBtn}
                onClick={(e) => {
                  addNewPassenger();
                }}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mr={1}
                >
                  <img src={PlusIcon} alt="plus" />
                </Box>
                <Typography variant="subtitle2">ADD PASSENGER</Typography>
              </Box>
            </Grid>
          )} */}
          </Grid>
        )}
        <Box>
          {fields?.map((field, index) => (
            <Forms
              key={field}
              field={field}
              index={index}
              activeFormIndex={activeIndex}
              handlePrevAction={handlePrevAction}
              handleNextAction={handleNextAction}
              currentValues={passengersValues[index]}
              extras={extras}
              airlines={airlines}
              control={control}
              selectedFlight={selectedFlight}
            />
          ))}
        </Box>
        {fields.length > 1 && (
          <Box className={classes.formNavigationBtns}>
            <Grid container spacing={1} justify="center">
              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {activeIndex > 0 && (
                    <Box
                      className={classes.actionBtn}
                      onClick={() => handlePrevAction()}
                    >
                      <Typography variant="subtitle2" color="secondary">
                        Prev passenger
                      </Typography>
                    </Box>
                  )}
                  {passengers - 1 !== activeIndex && (
                    <Box
                      className={classes.actionBtn}
                      onClick={() => handleNextAction()}
                    >
                      <Typography variant="subtitle2" color="secondary">
                        Next passenger
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Grid>
      <Grid item xs={12} md={4} className={classes.secondaryForm}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.contactBox}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={{ xs: 1, sm: 2 }}
            className={classes.icon}
          >
            <img src={PhoneContactIcon} alt="phone" />
          </Box>
          <Typography variant="h3">Contact Details</Typography>
          <Typography variant="body1" align="center">
            By providing my contact details I agree to be contacted in regards
            to this booking via phone, text and email.
          </Typography>
          <Box mt={2}>
            <CustomTextField label="E-mail" name="email" />
            <CustomPhoneNumber
              name="contactPhoneNumber"
              defaultValue={contactPhoneNumberVal}
            />
          </Box>
          <Box mb={1} mt={{ xs: 3, sm: 1 }}>
            <CustomSwitch
              name="contactDetailsSwitch"
              value={contactDetailsSwitchVal}
              label="I confirm that the passenger details are correct"
            />
          </Box>
          {!show && (
            <NextButton
              selectedFlight={selectedFlight}
              tipsValue={tipsValue}
              handleNext={handleNext}
              disabled={
                !contactDetailsSwitchVal || Object.keys(formErrors).length > 0
              }
              location="form"
            />
          )}
        <Box pt={8}>
          <FormOperator operatorInfo={operatorInfo} />
        </Box>
        <Box width={1}>
          <Accreditation />
        </Box>
      </Box>
      </Grid>
    </Grid>
  );
}
